import { createSlice } from "@reduxjs/toolkit";

export const EstateStatusListSlice = createSlice({
    name: "estateStatusList",
    initialState: {
        estateStatusList: null,
    },
    reducers: {
        setEstateStatusList: (state, action) => {
            state.estateStatusList = action.payload;
        },
        clearEstateStatusList: (state, action) => {
            state.estateStatusList = null;
        }
    }
})

export const { setEstateStatusList, clearEstateStatusList } = EstateStatusListSlice.actions;

export default EstateStatusListSlice.reducer;